import React from "react";
import { Navigate } from "react-router-dom";

// Convenience shortcut: /comunidad → /procesos/community
export default function CommunityRedirect() {
  return <Navigate to="/procesos/community" replace />;
}
